/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useCallback } from 'react';
import type { HookFetcher } from '../utils/types';
import { CommerceError } from '../utils/errors';
import useCommerceCheck from '../commerce/use-check';
import type { CheckBody, CheckResponseBody } from '../api/auth';
import useCustomer from '../customer/use-customer';

const defaultOpts = {
  url: '/api/maxify/auth',
  method: 'GET',
};

export type CheckInput = CheckBody;
export type CheckResult = CheckResponseBody;

export const fetcher: HookFetcher<CheckResponseBody, CheckBody> = (
  options,
  { email, username },
  fetch
) => {
  if (!email && !username) {
    throw new CommerceError({
      message: 'Invalid request.',
    });
  }

  const checkRequestParams = new URLSearchParams();
  if (email) {
    checkRequestParams.append('email', email);
  } else {
    checkRequestParams.append('username', username);
  }

  return fetch({
    ...defaultOpts,
    ...options,
    url: `${defaultOpts.url}?${checkRequestParams.toString()}`,
  });
};

export function extendHook(customFetcher: typeof fetcher) {
  const useCheck = () => {
    const { mutate } = useCustomer();
    const fn = useCommerceCheck<CheckResult, CheckInput>(
      defaultOpts,
      customFetcher
    );

    return useCallback(
      async function check(input: CheckInput) {
        const data = await fn(input);
        await mutate();
        return data;
      },
      [fn, mutate]
    );
  };

  useCheck.extend = extendHook;

  return useCheck;
}

export default extendHook(fetcher);
